import { Bot, Building2, FileText, Globe, Users } from 'lucide-react';
import { Navigate, useNavigate, useParams } from 'react-router-dom';
import { LiksPage } from '../../components/liks/LiksPage/LiksPage';
import { LiksTabs } from '../../components/liks/LiksTabs/LiksTabs';
import { useI18n } from '../../i18n/useI18n';
import './LacPage.css';
import {
  DEFAULT_LAC_TAB,
  isLacTabId,
  resolveLacTabPath,
  type LacTabId,
} from '../../routes/lacPaths';
import { LacChatbotsTab } from './tabs/LacChatbotsTab';
import { LacDocumentsTab } from './tabs/LacDocumentsTab';
import { LacTenantsTab } from './tabs/LacTenantsTab';
import { LacUsersTab } from './tabs/LacUsersTab';
import { LacWebsiteCrawlsTab } from './tabs/LacWebsiteCrawlsTab';

export function LacPage() {
  const { translate } = useI18n();
  const navigate = useNavigate();
  const { tab } = useParams<{ tab?: string }>();

  if (!isLacTabId(tab)) {
    return <Navigate to={resolveLacTabPath(DEFAULT_LAC_TAB)} replace />;
  }

  const activeTabId: LacTabId = tab;

  const handleTabChange = (nextTabId: string) => {
    if (!isLacTabId(nextTabId)) {
      return;
    }
    navigate(resolveLacTabPath(nextTabId));
  };

  const tabs = [
    {
      id: 'users',
      label: translate('lac.tabs.users'),
      icon: <Users strokeWidth={2} aria-hidden />,
      content: <LacUsersTab />,
    },
    {
      id: 'organisations',
      label: translate('lac.tabs.organisations'),
      icon: <Building2 strokeWidth={2} aria-hidden />,
      content: <LacTenantsTab />,
    },
    {
      id: 'chatbots',
      label: translate('lac.tabs.chatbots'),
      icon: <Bot strokeWidth={2} aria-hidden />,
      content: <LacChatbotsTab />,
    },
    {
      id: 'documents',
      label: translate('lac.tabs.documents'),
      icon: <FileText strokeWidth={2} aria-hidden />,
      content: <LacDocumentsTab />,
    },
    {
      id: 'website-crawls',
      label: translate('lac.tabs.websiteCrawls'),
      icon: <Globe strokeWidth={2} aria-hidden />,
      content: <LacWebsiteCrawlsTab />,
    },
  ];

  return (
    <LiksPage
      className="lac-page"
      header={<h1>{translate('lac.title')}</h1>}
      content={
        <div className="lac-page__content">
          <LiksTabs
            tabs={tabs}
            activeTabId={activeTabId}
            onActiveTabIdChange={handleTabChange}
            aria-label={translate('lac.tabs.legend')}
          />
        </div>
      }
    />
  );
}
